import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Addendum, AddendumServicesResponse } from '../models/addendum.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable({
  providedIn: 'root'
})
export class AddendumService {
  private baseUrl: string;
  private api: string = "api/AddendumServices";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Addendum Service Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }


  async AddendumServices_CreateAsync(encryptedUser: string, addendum: AddendumServicesResponse): Promise<AddendumServicesResponse | void> {
    const a = await this.httpClient.post<AddendumServicesResponse>(`${this.baseUrl}/AddendumServices_Create`, addendum, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, addendum, "", encryptedUser, "AddendumService", "AddendumServices_CreateAsync"); });

    return a;
  }

  async AddendumServices_GetAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<AddendumServicesResponse | void> {
    const a = await this.httpClient
      .get<AddendumServicesResponse>(`${this.baseUrl}/AddendumServices_Get/${inventionId}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "InventionID - " + inventionId + "ContractSessionId - " + contractSessionId, encryptedUser, "AddendumService", "AddendumServices_GetAsync"); });

    return a;
  }
}
